import * as actionTypes from '../actions/actionsTypes';

import { updateObject } from '../../utils/common';

const initialState = {
  loadedFrom: '',
};

const setLoadedFrom = (state, action) => {
  return updateObject(state, {
    loadedFrom: action.data,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETLOADEDFROM:
      return setLoadedFrom(state, action);
    default:
      return state;
  }
};

export default reducer;
